import { render, staticRenderFns } from "./addCompaniesDialog.vue?vue&type=template&id=4c571856"
import script from "./addCompaniesDialog.vue?vue&type=script&lang=js"
export * from "./addCompaniesDialog.vue?vue&type=script&lang=js"
import style0 from "./addCompaniesDialog.vue?vue&type=style&index=0&id=4c571856&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c571856')) {
      api.createRecord('4c571856', component.options)
    } else {
      api.reload('4c571856', component.options)
    }
    module.hot.accept("./addCompaniesDialog.vue?vue&type=template&id=4c571856", function () {
      api.rerender('4c571856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/sector/addCompaniesDialog.vue"
export default component.exports